import { useMemo } from 'react';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import avatar from '../../assets/images/avatar.png';
import logoState from '../../assets/images/logo_state.png';
import { Category } from '../Category';
import {
	StyledCategoriesGrid,
	StyledContainer,
	StyledDecBottom,
	StyledDecUp,
	StyledDividers,
	StyledHead,
	StyledHeadText,
	StyledInfoBottom,
	StyledInfoTop,
	StyledMainContainer,
	StyledRightContainer,
	StyledStateName,
	StyledValue,
} from './License.styled';

const License = () => {
	const nickname = useObservable(rage.player.getNickname());
	const licenses = useObservable(rage.licenses.getLicenses());

	const filteredLicenses = useMemo(() => {
		return licenses?.filter((license) => license.isOwned);
	}, [licenses]);

	return (
		<StyledContainer>
			<StyledHead>
				<img src={logoState} />
				<StyledHeadText>
					<StyledStateName />
					<Text
						style={{
							fontSize: 12,
							fontWeight: 500,
							color: '#000000',
							opacity: 0.5,
						}}
					>
						ВОДИТЕЛЬСКОЕ УДОСТОВЕРЕНИЕ USA
					</Text>
				</StyledHeadText>
			</StyledHead>
			<StyledDividers>
				<Divider $direction="H" $color="#FFFFFF" style={{ opacity: 0.25 }} />
				<Divider $direction="H" $color="#000000" style={{ opacity: 0.1 }} />
			</StyledDividers>
			<StyledMainContainer>
				<StyledDecUp />
				<img src={avatar} />
				<StyledRightContainer>
					<StyledInfoTop>
						<StyledValue>
							<Text>Имя Фамилия:</Text>
							<Text>{nickname}</Text>
						</StyledValue>
						<StyledValue style={{ alignItems: 'flex-end' }}>
							<Text>Дата выдачи:</Text>
							<Text>24.11.2025</Text>
						</StyledValue>
					</StyledInfoTop>
					<StyledInfoBottom>
						<Text>Доступные категории:</Text>
						<StyledCategoriesGrid>
							{filteredLicenses?.map((license) => (
								<Category
									letter={license.letter}
									date={new Date(license?.issueDate ?? 0).toLocaleDateString(
										'ru-RU',
										{
											day: '2-digit',
											month: '2-digit',
											year: '2-digit',
											timeZone: 'Europe/Moscow',
										},
									)}
									key={license.id}
								/>
							))}
						</StyledCategoriesGrid>
					</StyledInfoBottom>
				</StyledRightContainer>
			</StyledMainContainer>
			<StyledDecBottom />
		</StyledContainer>
	);
};

export { License };
